import { render, staticRenderFns } from "./NavigationLink.vue?vue&type=template&id=abb1dd1e&"
import script from "./NavigationLink.vue?vue&type=script&lang=js&"
export * from "./NavigationLink.vue?vue&type=script&lang=js&"
import style0 from "./NavigationLink.vue?vue&type=style&index=0&id=abb1dd1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports